import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles( () => ( {
	pentagon: {
		clipPath: 'polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%)'
	}
} ) )
